// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1P-ga","decrement-button":"decrement-button--3Ky0B","increment-button":"increment-button--1hgNs","value":"value--1Kcr3"};